var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _path36, _g2, _path37, _g3, _path38, _g4, _path39, _g5, _path40, _g6, _path41, _g7, _path42, _g8, _path43, _g9, _path44, _g0, _path45, _path46, _g1, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTyperMaping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 161,
    viewBox: "0 0 142 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6546 72.3005C72.7128 75.4161 70.5426 79.2601 67.8111 80.8928C65.0796 82.5252 62.817 81.3272 62.7588 78.2133C62.7041 75.1019 64.8742 71.2538 67.6057 69.621C70.3372 67.9886 72.5998 69.1891 72.6546 72.3005Z",
    fill: "#C6ABC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9793 74.0298L81.7509 76.7856C83.0071 77.5116 84.0922 77.132 84.3558 75.8789L86.324 65.2677L72.4062 57.2306L74.3744 70.115C74.638 71.6752 75.7231 73.3038 76.9793 74.0298Z",
    fill: "#474743"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3934 74.9512L80.1684 77.7097C81.4212 78.4316 82.5063 78.0561 82.7698 76.7992L84.738 66.1881L70.8203 58.1547L72.7885 71.035C73.0521 72.5969 74.1372 74.2293 75.3934 74.9512Z",
    fill: "#61615E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6199 78.8705L73.395 81.6287C74.6478 82.3523 75.7328 81.971 75.9964 80.7182L77.9646 70.1071L64.0469 62.0713L66.0151 74.954C66.2786 76.5159 67.3637 78.1483 68.6199 78.8705Z",
    fill: "#474743"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9915 79.7936L71.7665 82.5494C73.0228 83.2754 74.1078 82.8955 74.3714 81.6389L76.3396 71.0277L62.4219 62.9944L64.3901 75.8746C64.6536 77.4348 65.7387 79.069 66.9915 79.7936Z",
    fill: "#61615E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0474 74.3239L67.4224 72.3626C66.998 72.6101 66.7379 73.1328 66.7344 73.8762C66.731 75.3683 67.7853 77.2002 69.086 77.9488L65.711 79.9143C64.4068 79.1616 63.3526 77.3337 63.3594 75.8376C63.3594 75.0941 63.623 74.5714 64.0474 74.3239Z",
    fill: "#454541"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7901 78.1129L67.4116 80.0784C66.9838 80.3245 66.3882 80.2896 65.7344 79.9138L69.1094 77.9483C69.7666 78.3296 70.3622 78.3628 70.7901 78.1129Z",
    fill: "#454541"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4453 73.2903L66.8238 71.3286C67.4091 70.9904 68.2169 71.0386 69.1069 71.5521L65.7284 73.5134C64.8384 73 64.0306 72.9521 63.4453 73.2903Z",
    fill: "#ABABA9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3954 79.1481L68.0204 81.1135C68.5955 80.7781 68.9549 80.0654 68.9583 79.056C68.9617 77.0234 67.5275 74.5353 65.7578 73.5149L69.1363 71.5536C70.906 72.5736 72.3402 75.058 72.3333 77.0916C72.3299 78.1013 71.9739 78.814 71.3954 79.1481Z",
    fill: "#ABABA9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7083 79.9138C67.009 80.6641 68.0736 80.0569 68.077 78.5621C68.0804 77.0659 67.0261 75.2408 65.722 74.4881C64.4213 73.7354 63.3601 74.3409 63.3567 75.8371C63.3499 77.3333 64.4041 79.1611 65.7083 79.9138ZM65.7254 73.5132C67.495 74.5336 68.9293 77.0218 68.9259 79.0543C68.919 81.0879 67.4745 81.9091 65.7049 80.8887C63.9352 79.8659 62.501 77.3801 62.5078 75.3479C62.5113 73.314 63.9557 72.4891 65.7254 73.5132Z",
    fill: "#757572"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1371 17.7256L83.7626 17.3005C83.8687 16.2465 83.0061 14.9965 81.4658 13.9535C77.7896 11.4681 71.6419 10.9827 68.0376 12.8787C67.2469 13.2956 65.9325 14.1821 65.9838 15.4657L61.599 15.6369C61.4895 12.9468 63.088 10.524 65.9838 8.99705C71.0258 6.33365 78.9055 6.91897 83.9235 10.3139C86.8638 12.3036 88.4007 15.0047 88.1371 17.7256Z",
    fill: "#FFD98E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1371 27.374L83.7626 26.9503C83.8687 25.8967 83.0061 24.6439 81.4658 23.6023C77.7896 21.1138 71.6419 20.6284 68.0376 22.5271C67.2469 22.9416 65.9325 23.8323 65.9838 25.1118L61.599 25.2871C61.4895 22.5928 63.088 20.1725 65.9838 18.6428C71.0258 15.9835 78.9055 16.565 83.9235 19.964C86.8638 21.9497 88.4007 24.6504 88.1371 27.374Z",
    fill: "#FFD98E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1371 37.0212L83.7626 36.5961C83.8687 35.5425 83.0061 34.2894 81.4658 33.2478C77.7896 30.7596 71.6419 30.2743 68.0376 32.1743C67.2469 32.5913 65.9325 33.4778 65.9838 34.7576L61.599 34.9326C61.4895 32.2425 63.088 29.8183 65.9838 28.2886C71.0258 25.6252 78.9055 26.215 83.9235 29.6099C86.8638 31.5979 88.4007 34.299 88.1371 37.0212Z",
    fill: "#FFD98E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8375 14.2727C78.1827 13.5199 78.2135 12.2764 76.906 11.497C75.6018 10.7159 73.4522 10.6919 72.1104 11.4487C70.7652 12.2014 70.7378 13.4436 72.042 14.2244C73.3495 15.0055 75.4957 15.0281 76.8375 14.2727ZM79.8086 16.0481C76.7793 17.7504 71.9324 17.7021 68.9853 15.9386C66.0381 14.1802 66.11 11.3724 69.1393 9.67186C72.1721 7.971 77.0155 8.01892 79.9627 9.7814C82.9098 11.5408 82.8414 14.3476 79.8086 16.0481Z",
    fill: "#9A9A98"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9109 55.7686C84.2703 56.1205 84.6263 56.4775 84.9857 56.829C87.8028 59.6157 87.0976 63.2471 82.9285 65.5884L82.0625 63.6441C85.8141 61.5424 86.4439 58.2745 83.9109 55.7686Z",
    fill: "#ABABA9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6624 56.7682C64.0218 56.4153 64.3812 56.0638 64.7406 55.7147C62.2487 58.1508 62.769 61.3478 66.346 63.4872C70.6281 66.0479 77.676 66.1201 82.0813 63.645L82.9473 65.5892C78.0456 68.3409 70.2105 68.2594 65.4458 65.4112C61.4683 63.0353 60.8898 59.4799 63.6624 56.7682Z",
    fill: "#ABABA9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4444 56.0709L85.4341 59.042C85.4307 60.7185 84.3045 62.39 82.0625 63.6455L82.0727 60.6785C84.3113 59.4192 85.441 57.7478 85.4444 56.0709Z",
    fill: "#757572"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1719 58.9788L63.1787 56.008C63.1753 57.6298 64.2227 59.2557 66.3278 60.5154C70.6134 63.0757 77.6578 63.148 82.0665 60.6769L82.0563 63.6439C77.651 66.1191 70.6031 66.0469 66.321 63.4861C64.2124 62.2268 63.1685 60.6009 63.1719 58.9788Z",
    fill: "#757572"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2362 60.1703C85.1623 57.9652 85.2514 54.3297 81.4348 52.05C77.6182 49.7676 71.3405 49.7022 67.4144 51.9069C63.4882 54.112 63.3993 57.7461 67.2158 60.0258C71.0324 62.3096 77.3067 62.3736 81.2362 60.1703ZM82.0817 60.6769C77.6729 63.1479 70.6285 63.0757 66.343 60.5153C62.0609 57.9546 62.1601 53.8751 66.5655 51.4003C70.9742 48.9293 78.0221 48.9974 82.3042 51.5605C86.5897 54.1212 86.487 58.2021 82.0817 60.6769Z",
    fill: "#ABABA9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6715 60.4674L86.6578 64.9826C86.6509 66.8481 85.3982 68.7065 82.9062 70.1064L82.9199 65.5885C85.4118 64.1926 86.6646 62.334 86.6715 60.4674Z",
    fill: "#757572"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2275 53.3012L84.2207 56.0666C84.2173 57.56 83.2109 59.0521 81.2188 60.1714L81.2256 57.4049C83.2212 56.2856 84.2241 54.7977 84.2275 53.3012Z",
    fill: "#696966"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9219 64.9147L61.9321 60.3995C61.9287 62.2031 63.0926 64.0111 65.4339 65.4107C70.1986 68.259 78.0337 68.3405 82.9354 65.5887L82.9217 70.1067C78.02 72.8557 70.1849 72.7769 65.4236 69.929C63.0789 68.5291 61.9151 66.7186 61.9219 64.9147Z",
    fill: "#757572"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4063 56.0109L64.4131 53.2459C64.4096 54.69 65.3441 56.142 67.2199 57.2641C71.0365 59.5438 77.3142 59.6091 81.2403 57.4044L81.2334 60.1709C77.3039 62.3742 71.0296 62.3102 67.2131 60.0264C65.3339 58.9071 64.4028 57.4565 64.4063 56.0109Z",
    fill: "#696966"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6852 56.4629C82.7179 54.762 82.7863 51.9556 79.8392 50.1917C76.8955 48.4337 72.0486 48.3813 69.0158 50.0822C65.9865 51.7844 65.9181 54.5909 68.8652 56.353C71.809 58.1128 76.6559 58.1648 79.6852 56.4629ZM81.2631 57.4042C77.337 59.609 71.0593 59.5436 67.2428 57.2639C63.4262 54.9815 63.5152 51.3459 67.4413 49.1409C71.3674 46.9399 77.6451 47.0015 81.4617 49.2853C85.2782 51.565 85.1893 55.2005 81.2631 57.4042Z",
    fill: "#ABABA9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1535 12.8821L81.9926 53.2945C81.9892 54.447 81.2156 55.5982 79.6719 56.4635L79.8327 16.0483C81.3731 15.1861 82.1501 14.0363 82.1535 12.8821Z",
    fill: "#565652"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6719 53.2522L66.8328 12.8373C66.8294 13.9535 67.5482 15.0728 68.9961 15.9378C71.9432 17.7013 76.7901 17.7496 79.8194 16.0474L79.6586 56.4625C76.6293 58.1644 71.7824 58.1124 68.8386 56.3527C67.3873 55.4877 66.6685 54.3687 66.6719 53.2522Z",
    fill: "#565652"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3265 44.4854C72.6161 44.4854 68.7584 43.4612 65.8558 41.4971C63.2201 39.7175 61.714 37.3827 61.625 34.9281L66.0098 34.7607C66.0509 35.7678 66.8895 36.8963 68.3168 37.8616C71.9828 40.3405 78.1339 40.8365 81.7451 38.934C82.9807 38.2802 83.7064 37.4512 83.7886 36.5927L88.1631 37.0233C87.9269 39.3951 86.3763 41.4557 83.7954 42.8156C81.6698 43.9373 79.0375 44.4854 76.3265 44.4854Z",
    fill: "#FFF4BA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3265 34.8369C72.6161 34.8369 68.7584 33.8169 65.8558 31.8524C63.2201 30.0687 61.714 27.7384 61.625 25.2835L66.0098 25.1164C66.0509 26.1217 66.8895 27.2489 68.3168 28.2142C71.9828 30.6958 78.1339 31.188 81.7451 29.2852C82.9807 28.6342 83.7064 27.8024 83.7886 26.9467L88.1631 27.3786C87.9269 29.7507 86.3763 31.8083 83.7954 33.171C81.6698 34.2927 79.0375 34.8369 76.3265 34.8369Z",
    fill: "#FFF4BA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3265 25.1902C72.6161 25.1902 68.7584 24.1674 65.8558 22.202C63.2201 20.4224 61.714 18.0875 61.625 15.6367L66.0098 15.4697C66.0509 16.4726 66.8895 17.6022 68.3168 18.5664C71.9828 21.0494 78.1339 21.5413 81.7451 19.6388C82.9807 18.9847 83.7064 18.156 83.7886 17.2975L88.1631 17.7281C87.9269 20.104 86.3763 22.1619 83.7954 23.5229C81.6698 24.6435 79.0375 25.1902 76.3265 25.1902Z",
    fill: "#FFF4BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8984 128.021L47.7192 142.226C63.9611 152.334 91.3036 139.134 110.547 111.213C112.184 108.839 113.71 106.429 115.131 103.999L92.3065 89.7933C90.8894 92.2201 89.3594 94.6295 87.7232 97.0082C68.4794 124.929 41.1369 138.129 24.8984 128.021Z",
    fill: "#20201C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3203 89.793L115.145 103.998C131.277 76.3644 133.153 46.161 118.626 33.968C117.856 33.3249 117.051 32.7392 116.219 32.2152L93.3985 18.0099C94.2303 18.5298 95.0313 19.1155 95.8015 19.7628C110.332 31.9557 108.453 62.1592 92.3203 89.793Z",
    fill: "#20201C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4609 107.808L39.5685 110.362C49.8716 116.776 67.2191 108.404 79.4253 90.6903C80.4659 89.1807 81.4346 87.6496 82.3348 86.1093L78.2307 83.5527C77.3305 85.0971 76.3584 86.6227 75.3212 88.1323C63.1115 105.846 45.764 114.223 35.4609 107.808Z",
    fill: "#2A2A26"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2109 83.5533L82.315 86.1099C92.5497 68.5778 93.7408 49.4161 84.5228 41.6809C84.0368 41.2733 83.5268 40.9002 82.9996 40.5712L78.8921 38.0146C79.4192 38.3463 79.9292 38.7167 80.4187 39.1271C89.6367 46.8595 88.4456 66.024 78.2109 83.5533Z",
    fill: "#2A2A26"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1043 60.2152C55.9609 41.5638 74.5099 33.2659 84.5357 41.6802C94.5649 50.0972 92.275 72.0377 79.4184 90.6901C66.5652 109.338 48.0162 117.635 37.987 109.222C27.9612 100.808 30.2511 78.8662 43.1043 60.2152ZM29.7616 125.477C44.2339 137.622 70.9979 125.648 89.5469 98.734C108.096 71.8224 111.402 40.1642 96.9302 28.0192C82.4613 15.8769 55.6939 27.8508 37.1484 54.7624C18.5994 81.674 15.2928 113.336 29.7616 125.477Z",
    fill: "#181815"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2344 122.108L64.3385 124.665C74.6416 131.08 91.9891 122.703 104.199 104.989C105.236 103.48 106.208 101.954 107.105 100.41L103.001 97.8558C102.1 99.3961 101.128 100.927 100.091 102.433C87.8816 120.147 70.5375 128.522 60.2344 122.108Z",
    fill: "#2A2A26"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M102.984 97.8564L107.088 100.41C117.327 82.881 118.514 63.7193 109.3 55.9841C108.81 55.5737 108.3 55.2033 107.773 54.8716L103.666 52.3154C104.193 52.6467 104.703 53.0157 105.192 53.4278C114.41 61.1627 113.219 80.3247 102.984 97.8564Z",
    fill: "#2A2A26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 33,
    width: 83,
    height: 98
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9355 110.643C75.7999 100.688 90.4843 75.8317 90.7376 55.1256C90.8677 44.6038 87.2428 37.1791 81.304 33.7253L101.811 45.644C102.916 46.2872 103.947 47.0683 104.881 47.9826L108.349 49.9977C114.226 53.4141 117.813 60.7639 117.683 71.1731C117.433 91.6629 102.903 116.256 85.2266 126.104C76.5358 130.948 68.7007 131.324 63.0117 128.021C62.1492 127.518 61.3379 126.929 60.578 126.261C58.935 125.902 57.3981 125.311 55.9913 124.495C49.8402 120.919 41.6354 116.154 35.4844 112.576C41.2315 115.918 49.1488 115.538 57.9355 110.643Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9355 110.643C75.7999 100.688 90.4843 75.8317 90.7376 55.1256C90.8677 44.6038 87.2428 37.1791 81.304 33.7253L101.811 45.644C102.916 46.2872 103.947 47.0683 104.881 47.9826L108.349 49.9977C114.226 53.4141 117.813 60.7639 117.683 71.1731C117.433 91.6629 102.903 116.256 85.2266 126.104C76.5358 130.948 68.7007 131.324 63.0117 128.021C62.1492 127.518 61.3379 126.929 60.578 126.261C58.935 125.902 57.3981 125.311 55.9913 124.495C49.8402 120.919 41.6354 116.154 35.4844 112.576C41.2315 115.918 49.1488 115.538 57.9355 110.643Z",
    fill: "url(#paint0_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 34,
    width: 74,
    height: 91
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9355 110.643C75.7999 100.688 90.4843 75.8318 90.7376 55.1257C90.8643 44.977 87.4893 37.7206 81.9201 34.1197L92.4936 40.2639C93.5992 40.9071 94.6261 41.6906 95.564 42.6049L99.0314 44.6172C104.909 48.0337 108.492 55.3824 108.366 65.7954C108.116 86.2811 93.5821 110.876 75.9094 120.727C67.2151 125.57 59.3834 125.943 53.6944 122.641C52.8319 122.137 52.0206 121.552 51.2607 120.885C49.8744 120.58 48.5703 120.1 47.3518 119.475C43.2374 117.081 39.0237 114.634 35.4844 112.576C41.2315 115.918 49.1488 115.538 57.9355 110.643Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.9355 110.643C75.7999 100.688 90.4843 75.8318 90.7376 55.1257C90.8643 44.977 87.4893 37.7206 81.9201 34.1197L92.4936 40.2639C93.5992 40.9071 94.6261 41.6906 95.564 42.6049L99.0314 44.6172C104.909 48.0337 108.492 55.3824 108.366 65.7954C108.116 86.2811 93.5821 110.876 75.9094 120.727C67.2151 125.57 59.3834 125.943 53.6944 122.641C52.8319 122.137 52.0206 121.552 51.2607 120.885C49.8744 120.58 48.5703 120.1 47.3518 119.475C43.2374 117.081 39.0237 114.634 35.4844 112.576C41.2315 115.918 49.1488 115.538 57.9355 110.643Z",
    fill: "url(#paint1_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 68,
    width: 20,
    height: 9
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2891 75.3195C94.1986 75.9051 98.4738 74.5839 102.41 72.3939C104.56 71.1945 106.607 69.7411 108.263 68.1994L110.834 69.6863C109.177 71.2225 107.13 72.6773 104.981 73.8753C99.5931 76.8769 93.5585 78.257 91.2891 75.3195Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2891 75.3195C94.1986 75.9051 98.4738 74.5839 102.41 72.3939C104.56 71.1945 106.607 69.7411 108.263 68.1994L110.834 69.6863C109.177 71.2225 107.13 72.6773 104.981 73.8753C99.5931 76.8769 93.5585 78.257 91.2891 75.3195Z",
    fill: "url(#paint2_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 42,
    width: 29,
    height: 30
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2167 43.8267C91.1243 51.4801 85.6168 67.044 79.0139 70.7236C76.4296 72.1651 74.0609 71.5619 72.1406 69.8412C73.4687 70.2236 74.9167 70.0911 76.4433 69.2381C83.0462 65.5625 88.5537 49.9946 88.6495 42.3412C93.1062 41.9335 97.0426 42.9361 100.209 45.1987C97.5697 44.0006 94.537 43.5218 91.2167 43.8267Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2167 43.8267C91.1243 51.4801 85.6168 67.044 79.0139 70.7236C76.4296 72.1651 74.0609 71.5619 72.1406 69.8412C73.4687 70.2236 74.9167 70.0911 76.4433 69.2381C83.0462 65.5625 88.5537 49.9946 88.6495 42.3412C93.1062 41.9335 97.0426 42.9361 100.209 45.1987C97.5697 44.0006 94.537 43.5218 91.2167 43.8267Z",
    fill: "url(#paint3_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 100,
    width: 8,
    height: 26
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5628 125.457L67.9922 123.971C71.4014 116.779 73.5134 104.689 70.6621 100.496L71.4528 100.612C76.7412 102.133 74.5198 117.101 70.5628 125.457Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5628 125.457L67.9922 123.971C71.4014 116.779 73.5134 104.689 70.6621 100.496L71.4528 100.612C76.7412 102.133 74.5198 117.101 70.5628 125.457Z",
    fill: "url(#paint4_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 87,
    width: 4,
    height: 3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.172 88.1685L102.617 87.6509C103.877 88.1483 104.958 88.8223 105.742 89.6541L103.172 88.1685Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.172 88.1685L102.617 87.6509C103.877 88.1483 104.958 88.8223 105.742 89.6541L103.172 88.1685Z",
    fill: "url(#paint5_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 75,
    width: 24,
    height: 44
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2266 103.882C45.8662 103.583 47.9062 102.762 50.0524 101.564C56.0939 98.1988 63.0288 91.8464 64.5999 85.6437C65.7021 81.2942 63.9427 77.8712 61.129 75.7346C65.3119 77.5115 68.5808 81.5601 67.1671 87.1293C65.5994 93.332 58.6645 99.6816 52.623 103.05C50.4734 104.248 48.4368 105.066 46.7972 105.367C47.0094 109.94 47.9884 113.843 49.5903 116.998C49.3267 117.495 49.0735 117.984 48.8475 118.456C46.1674 114.921 44.5107 109.999 44.2266 103.882Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2266 103.882C45.8662 103.583 47.9062 102.762 50.0524 101.564C56.0939 98.1988 63.0288 91.8464 64.5999 85.6437C65.7021 81.2942 63.9427 77.8712 61.129 75.7346C65.3119 77.5115 68.5808 81.5601 67.1671 87.1293C65.5994 93.332 58.6645 99.6816 52.623 103.05C50.4734 104.248 48.4368 105.066 46.7972 105.367C47.0094 109.94 47.9884 113.843 49.5903 116.998C49.3267 117.495 49.0735 117.984 48.8475 118.456C46.1674 114.921 44.5107 109.999 44.2266 103.882Z",
    fill: "url(#paint6_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 43,
    width: 65,
    height: 83
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3028 57.1474C62.3156 62.2202 57.9273 68.3332 54.4941 74.8892C60.7444 73.7662 69.295 78.7158 67.159 87.129C65.5913 93.3318 58.6564 99.6813 52.6149 103.05C50.4653 104.248 48.4287 105.066 46.7891 105.367C47.0732 111.48 48.7299 116.402 51.41 119.941C54.4599 113.516 61.5317 104.651 67.0427 101.584C68.7028 100.66 70.2192 100.259 71.4446 100.612C76.733 102.133 74.5115 117.101 70.5546 125.457C72.5844 124.915 74.6895 124.112 76.8563 123.023L76.9179 122.988L77.2533 122.817L77.4621 122.708L77.5888 122.642L77.9208 122.464L78.0098 122.416L78.376 122.214L78.7423 122.01L78.8279 121.961L79.1668 121.762L79.2797 121.698L79.5159 121.558L79.7624 121.406L79.9129 121.318C82.0797 119.989 84.1917 118.446 86.2283 116.722C82.4254 112.691 80.5428 100.007 85.9373 92.5349C87.1867 90.806 88.7168 89.5049 90.3769 88.5811C95.8879 85.5069 102.84 86.5581 105.766 89.6521C108.58 83.0519 110.374 76.206 110.819 69.6867C109.162 71.2229 107.115 72.6777 104.966 73.8757C98.9206 77.2439 92.0473 78.5864 90.6097 74.0602C88.662 67.9228 97.4487 53.314 103.754 47.4399C100.44 44.644 96.1411 43.3737 91.2121 43.8259C91.1163 51.4793 85.6087 67.0431 79.0059 70.7228C72.4098 74.3997 67.2104 64.8007 67.3028 57.1474Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3028 57.1474C62.3156 62.2202 57.9273 68.3332 54.4941 74.8892C60.7444 73.7662 69.295 78.7158 67.159 87.129C65.5913 93.3318 58.6564 99.6813 52.6149 103.05C50.4653 104.248 48.4287 105.066 46.7891 105.367C47.0732 111.48 48.7299 116.402 51.41 119.941C54.4599 113.516 61.5317 104.651 67.0427 101.584C68.7028 100.66 70.2192 100.259 71.4446 100.612C76.733 102.133 74.5115 117.101 70.5546 125.457C72.5844 124.915 74.6895 124.112 76.8563 123.023L76.9179 122.988L77.2533 122.817L77.4621 122.708L77.5888 122.642L77.9208 122.464L78.0098 122.416L78.376 122.214L78.7423 122.01L78.8279 121.961L79.1668 121.762L79.2797 121.698L79.5159 121.558L79.7624 121.406L79.9129 121.318C82.0797 119.989 84.1917 118.446 86.2283 116.722C82.4254 112.691 80.5428 100.007 85.9373 92.5349C87.1867 90.806 88.7168 89.5049 90.3769 88.5811C95.8879 85.5069 102.84 86.5581 105.766 89.6521C108.58 83.0519 110.374 76.206 110.819 69.6867C109.162 71.2229 107.115 72.6777 104.966 73.8757C98.9206 77.2439 92.0473 78.5864 90.6097 74.0602C88.662 67.9228 97.4487 53.314 103.754 47.4399C100.44 44.644 96.1411 43.3737 91.2121 43.8259C91.1163 51.4793 85.6087 67.0431 79.0059 70.7228C72.4098 74.3997 67.2104 64.8007 67.3028 57.1474Z",
    fill: "url(#paint7_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 77,
    width: 14,
    height: 16
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9263 77.8549C75.5205 79.7537 72.7205 84.5016 72.6726 88.4514C72.6212 92.4025 75.3425 94.0726 78.7517 92.1725C82.1679 90.2697 84.9678 85.5258 85.0157 81.5747C85.0636 77.6222 82.3424 75.9508 78.9263 77.8549Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9263 77.8549C75.5205 79.7537 72.7205 84.5016 72.6726 88.4514C72.6212 92.4025 75.3425 94.0726 78.7517 92.1725C82.1679 90.2697 84.9678 85.5258 85.0157 81.5747C85.0636 77.6222 82.3424 75.9508 78.9263 77.8549Z",
    fill: "url(#paint8_linear_3035_51698)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 78,
    width: 10,
    height: 13
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9625 79.3812C80.3894 78.0281 82.3267 79.2087 82.2925 82.0124C82.2583 84.8165 80.2661 88.1871 77.8393 89.5429C75.4192 90.8881 73.4818 89.7076 73.5161 86.9035C73.5503 84.1011 75.5425 80.7288 77.9625 79.3812Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9625 79.3812C80.3894 78.0281 82.3267 79.2087 82.2925 82.0124C82.2583 84.8165 80.2661 88.1871 77.8393 89.5429C75.4192 90.8881 73.4818 89.7076 73.5161 86.9035C73.5503 84.1011 75.5425 80.7288 77.9625 79.3812Z",
    fill: "url(#paint9_linear_3035_51698)"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3758 47.5792C85.5782 44.1241 91.3493 42.9168 96.227 43.6829C98.0137 43.9636 99.7971 44.2446 101.584 44.5211C96.4871 43.7243 90.4627 44.9839 83.9865 48.5914C65.3349 58.9872 50 84.936 49.7365 106.556C49.6406 114.415 51.5472 120.62 54.912 124.835C53.7858 123.424 52.6562 122.011 51.5301 120.6C48.3091 116.561 46.4812 110.623 46.5737 103.095C46.827 82.3903 61.5149 57.5366 79.3758 47.5792Z",
    fill: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3035_51698",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 42,
    width: 63,
    height: 90
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M83.995 46.9392C93.5553 41.6138 102.171 41.1993 108.425 44.8348L110.615 46.1051C104.358 42.4736 95.7425 42.8868 86.1857 48.2136C66.7467 59.0442 50.765 86.0882 50.4877 108.622C50.3474 120.072 54.2906 128.153 60.7566 131.908L58.5659 130.635C52.1034 126.88 48.1602 118.797 48.3005 107.348C48.5743 84.818 64.5561 57.7739 83.995 46.9392Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3035_51698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.995 46.9392C93.5553 41.6138 102.171 41.1993 108.425 44.8348L110.615 46.1051C104.358 42.4736 95.7425 42.8868 86.1857 48.2136C66.7467 59.0442 50.765 86.0882 50.4877 108.622C50.3474 120.072 54.2906 128.153 60.7566 131.908L58.5659 130.635C52.1034 126.88 48.1602 118.797 48.3005 107.348C48.5743 84.818 64.5561 57.7739 83.995 46.9392Z",
    fill: "url(#paint10_linear_3035_51698)"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7068 129.644L53.4971 142.325C68.695 155.08 96.8043 142.503 116.284 114.241C135.764 85.9773 139.235 52.7267 124.037 39.9762C108.843 27.2216 80.7301 39.7982 61.2501 68.0619C41.7735 96.3239 38.2992 129.575 53.4971 142.325L58.7068 129.644C46.8223 119.669 49.5367 93.6577 64.7757 71.553C80.0112 49.4441 102 39.6096 113.885 49.5844C125.773 59.5593 123.058 85.5655 107.819 107.674C92.5837 129.781 70.5947 139.617 58.7068 129.644Z",
    fill: "#20201C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6972 106.842C53.4439 127.329 67.5704 135.955 85.2465 126.103C102.923 116.255 117.453 91.6622 117.703 71.1724C117.956 50.6857 103.83 42.0626 86.1536 51.9145C68.4809 61.762 53.9471 86.3567 53.6972 106.842ZM86.2015 48.2147C105.637 37.3803 121.174 46.8657 120.897 69.3956C120.619 91.9255 104.641 118.97 85.202 129.804C65.7631 140.634 50.2297 131.153 50.5036 108.623C50.7808 86.0931 66.7626 59.0452 86.2015 48.2147Z",
    fill: "#E3E3E4"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0922 68.9228C44.9714 65.6563 47.008 62.4151 49.209 59.2249C74.0835 23.1343 109.977 7.07962 129.381 23.363C137.158 29.8864 141.105 40.614 141.444 53.4473L141.567 58.0375C141.249 46.0198 137.552 35.9769 130.271 29.8666C112.102 14.6207 78.4957 29.6537 55.206 63.4461C53.1488 66.4306 51.2388 69.4671 49.4828 72.5238C31.3583 104.072 29.373 138.337 45.9367 152.234L46.4877 152.685C55.6715 159.963 68.6068 159.785 82.1275 153.571L77.9583 155.485C63.5203 162.122 49.7053 162.311 39.8986 154.541L39.3064 154.058C21.6166 139.213 23.7354 102.618 43.0922 68.9228Z",
    fill: "#20201C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3779 134.223C71.2002 144.981 94.9144 134.373 111.345 110.529C127.778 86.6884 130.708 58.6373 117.889 47.8793C105.067 37.1209 81.3527 47.728 64.9226 71.5723C48.489 95.4169 45.5589 123.465 58.3779 134.223ZM55.2356 63.4469C78.5253 29.6544 112.132 14.6215 130.301 29.8674C148.47 45.1129 144.318 84.8643 121.032 118.655C97.7418 152.446 64.1319 167.481 45.9663 152.235C27.7972 136.988 31.9458 97.2379 55.2356 63.4469Z",
    fill: "#181815"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M126.358 21.1517L99.7176 4.57158C79.7823 -7.8404 46.2135 8.36353 22.5883 42.6455C20.579 45.5615 18.7032 48.5179 16.9609 51.5034L43.5984 68.0835C45.3406 65.1031 47.2164 62.1416 49.2291 59.2252C72.8543 24.9474 106.42 8.74075 126.358 21.1517Z",
    fill: "#2A2A26"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6079 68.0845L16.9705 51.5044C-2.83468 85.4293 -5.14174 122.509 12.6952 137.478L39.3361 154.06C21.4991 139.091 23.8027 102.01 43.6079 68.0845Z",
    fill: "#2A2A26"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122.564 18.8019L122.663 18.8635C121.13 17.9116 119.596 16.9569 118.066 16.0009L117.844 15.8619L122.564 18.8019Z",
    fill: "#313131"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M115.119 14.1507L117.258 15.54C116.858 15.4476 116.847 15.4476 116.567 15.4476L113.609 13.2162L113.729 13.2843L115.119 14.1507Z",
    fill: "#313131"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M117.382 15.5806L117.564 15.6929L117.314 15.5727L115.609 14.4777L117.382 15.5806Z",
    fill: "#313131"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M107.291 9.27854L107.513 9.42163C105.98 8.46697 104.45 7.51504 102.919 6.56038L102.57 6.34097L107.291 9.27854Z",
    fill: "#313131"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M111.413 11.8554L112.423 12.4934L115.38 14.7249C112.553 12.7152 112.382 12.5951 110.599 11.4118L110.023 10.9932L111.413 11.8554Z",
    fill: "#313131"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.52 10.6636L109.982 10.9897L107.928 9.67534L107.75 9.56169L109.52 10.6636Z",
    fill: "#313131"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M121.982 18.4843L122.581 18.8022L117.861 15.8623L114.883 14.2668C116.416 15.2215 117.95 16.1738 119.48 17.1284L121.982 18.4843Z",
    fill: "#313131"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M122.425 18.7663L123.287 19.3037L122.541 19.0405L119.991 17.7983L119.125 17.2606L119.926 17.4105L122.425 18.7663Z",
    fill: "#313131"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M115.108 14.1519L113.719 13.2855L113.91 13.4231L115.108 14.1519Z",
    fill: "#313131"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M117.388 15.5803L115.615 14.4775L113.969 13.4851L114.373 13.964L117.388 15.5803Z",
    fill: "#313131"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M107.29 9.27905L102.57 6.34148L100.465 5.08869L99.7188 4.82512C101.252 5.77738 102.782 6.73204 104.312 7.68396L107.29 9.27905Z",
    fill: "#313131"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6951 3.29707L99.2486 4.54063L99.9948 4.8042L99.1322 4.26644L96.9278 3.06191L96.5376 2.88664L95.8359 2.75966L96.6951 3.29707Z",
    fill: "#313131"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.413 11.8538L110.023 10.9915L109.688 10.8002L111.413 11.8538Z",
    fill: "#313131"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M109.034 10.4105L109.5 10.6631L107.73 9.56122L104.711 7.94593C106.015 8.67467 107.737 9.67487 109.034 10.4105Z",
    fill: "#313131"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M113.596 13.7109C115.126 14.6656 116.659 15.6202 118.193 16.5725L117.354 16.5109L114.722 15.4665C113.189 14.5146 111.658 13.56 110.125 12.6053L113.596 13.7109Z",
    fill: "#313131"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M117.81 16.7935L118.672 17.3309L117.789 17.3792L115.113 16.4485L114.25 15.9069L115.174 15.7505L117.81 16.7935Z",
    fill: "#313131"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M112.375 12.4754L112.847 13.0155C111.79 12.5089 110.386 11.8147 109.311 11.3348L109.109 10.883L112.375 12.4754Z",
    fill: "#313131"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M112.909 13.1046L113.073 13.412L109.599 12.3129L109.359 11.4544C110.424 11.9439 112.067 12.2862 112.909 13.1046Z",
    fill: "#313131"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4162 4.27028C99.9462 5.22255 101.476 6.17723 103.01 7.12915L99.5389 6.02319C98.0089 5.07126 96.4754 4.1166 94.9453 3.16467L95.825 3.11368L98.4162 4.27028Z",
    fill: "#313131"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8001 1.94629L94.4803 2.8811L95.3565 2.83011L94.4974 2.29544L92.1732 1.36885L91.7522 1.26581L90.9375 1.413L91.8001 1.94629Z",
    fill: "#313131"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M111.235 11.7495L107.969 10.1582C107.117 9.72242 105.984 9.13813 105.125 8.713C105.46 8.76092 105.909 8.80234 106.237 8.88415C109.233 10.558 109.414 10.6569 111.235 11.7495Z",
    fill: "#313131"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M105.556 8.52051C105.22 8.47635 104.772 8.39353 104.433 8.38018C103.091 7.74385 101.297 6.90795 99.9453 6.29559L103.416 7.3947L105.556 8.52051Z",
    fill: "#313131"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M108.691 12.2946C109.492 12.7947 110.557 13.455 111.354 13.9551C111.936 14.3134 112.71 14.7961 113.288 15.1558L112.33 15.4033L109.581 14.664C108.051 13.7079 106.518 12.757 104.984 11.801L108.691 12.2946Z",
    fill: "#313131"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M112.802 15.6825L113.668 16.224L112.672 16.5769L109.886 15.9433L109.023 15.4059L110.054 14.9472L112.802 15.6825Z",
    fill: "#313131"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M107.814 10.3862C107.999 10.9438 108.005 10.9681 108.098 11.3689C106.985 10.9893 105.51 10.4611 104.387 10.1123L104.281 9.4209L107.814 10.3862Z",
    fill: "#313131"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M108.123 11.5122L108.212 12.0017L104.505 11.5163C104.477 11.146 104.436 10.6541 104.398 10.2875C105.518 10.65 107.017 11.1193 108.123 11.5122Z",
    fill: "#313131"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M93.543 2.85356C95.0731 3.80822 96.6065 4.75877 98.1366 5.71069L94.4295 5.21883C92.8995 4.26657 91.3694 3.31189 89.8359 2.35996L90.832 2.00432L93.543 2.85356Z",
    fill: "#313131"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5701 1.44311L89.3598 2.07568L90.3525 1.72004L89.4933 1.18639L87.0665 0.526119L86.6215 0.495304L85.7109 0.905707L86.5701 1.44311Z",
    fill: "#313131"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M106.621 9.66113L103.089 8.69312C102.206 8.33097 101.032 7.84424 100.148 7.49099C100.532 7.40952 101.042 7.28664 101.432 7.23427C104.54 8.64521 104.728 8.73077 106.621 9.66113Z",
    fill: "#313131"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M100.758 6.9302C100.367 7.01167 99.8437 7.10409 99.4603 7.21362C98.0775 6.68683 96.2291 6.00223 94.8359 5.49803L98.5464 5.98889L100.758 6.9302Z",
    fill: "#313131"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M103.496 11.7257C104.297 12.2217 105.361 12.886 106.162 13.382C106.741 13.7445 107.514 14.2244 108.096 14.5869L107.035 15.1284L104.191 14.6858C102.657 13.7353 101.124 12.7806 99.5938 11.8246L103.496 11.7257Z",
    fill: "#313131"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M107.491 15.4123L108.353 15.9497L107.261 16.6011L104.386 16.2615L103.523 15.7238L104.646 14.9711L107.491 15.4123Z",
    fill: "#313131"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M102.829 9.16406C102.918 9.98249 102.921 10.0133 102.952 10.5706C101.795 10.3138 100.258 9.95578 99.0943 9.73226L99.0703 8.8043L102.829 9.16406Z",
    fill: "#313131"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M102.979 10.7728L103.003 11.4413L99.0938 11.5471C99.1006 11.071 99.104 10.4374 99.104 9.96262C100.268 10.2019 101.822 10.5028 102.979 10.7728Z",
    fill: "#313131"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3397 2.28528C89.8732 3.23618 91.4032 4.18811 92.9333 5.14278L89.0311 5.2417C87.4976 4.29114 85.9676 3.33647 84.4375 2.38421L85.526 1.73317L88.3397 2.28528Z",
    fill: "#313131"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M81.097 1.76165L83.9723 2.09985L85.0642 1.45017L84.2016 0.912767L81.6891 0.515713L81.2236 0.553026L80.2344 1.22427L81.097 1.76165Z",
    fill: "#313131"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M101.687 8.43652L97.9287 8.08088C97.0216 7.78685 95.8168 7.39219 94.9062 7.10877C95.3341 6.90682 95.8989 6.62203 96.337 6.44027C99.5409 7.59825 99.7326 7.66636 101.687 8.43652Z",
    fill: "#313131"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6228 6.19171C95.188 6.40017 94.5993 6.66339 94.1748 6.88965C92.7577 6.47102 90.8614 5.92678 89.4375 5.52972L93.3431 5.42804L95.6228 6.19171Z",
    fill: "#313131"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M98.063 11.9798C98.864 12.4758 99.9286 13.1388 100.73 13.6365C101.308 13.9987 102.082 14.4775 102.66 14.8411L101.517 15.6729L98.597 15.5191C97.0636 14.5631 95.5301 13.6085 94 12.6562L98.063 11.9798Z",
    fill: "#313131"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M101.935 15.957L102.801 16.4944L101.63 17.4292L98.6863 17.3782L97.8203 16.8367L99.0149 15.8033L101.935 15.957Z",
    fill: "#313131"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M97.584 8.78245C97.584 9.89354 97.5839 9.89354 97.5703 10.6062C96.3756 10.4724 94.784 10.2745 93.5859 10.1715C93.5996 9.82542 93.6202 9.36401 93.6304 9.01761L97.584 8.78245Z",
    fill: "#313131"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5714 10.8625L97.5508 11.7008L93.4844 12.3854C93.5152 11.8038 93.5597 11.0337 93.5871 10.4521C94.7817 10.5709 96.3802 10.7116 97.5714 10.8625Z",
    fill: "#313131"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8834 2.53786C84.4168 3.48978 85.9469 4.44034 87.4769 5.39637L83.4105 6.07446C81.8804 5.11843 80.3504 4.16752 78.8203 3.21559L79.9841 2.27704L82.8834 2.53786Z",
    fill: "#313131"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4217 2.87486L78.3689 2.93237L79.5361 1.99518L78.6735 1.45777L76.096 1.31468L75.6099 1.41601L74.5625 2.34157L75.4217 2.87486Z",
    fill: "#313131"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4038 8.05727L92.4537 8.28967C91.5261 8.0665 90.2904 7.76289 89.3594 7.54656C89.8283 7.22549 90.441 6.78017 90.9203 6.47142C94.2645 7.40349 94.3979 7.4408 96.4038 8.05727Z",
    fill: "#313131"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M90.211 6.27809C89.742 6.60703 89.1122 7.0349 88.6535 7.3772C87.2056 7.06571 85.2716 6.65802 83.8203 6.36776L87.8868 5.68592L90.211 6.27809Z",
    fill: "#313131"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3616 13.0288C93.895 13.9849 95.4251 14.9395 96.9586 15.8914L95.7503 17.0066L92.7723 17.1299C91.2388 16.1752 89.7054 15.2229 88.1719 14.2683L92.3616 13.0288Z",
    fill: "#313131"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2117 17.2915L97.0777 17.8293L95.8489 19.0431L92.847 19.2666L91.9844 18.7288L93.2338 17.4148L96.2117 17.2915Z",
    fill: "#313131"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0559 9.21942C91.9909 10.578 91.9909 10.578 91.9395 11.4443C90.7141 11.4269 89.0848 11.3896 87.8594 11.4029C87.8902 10.9898 87.9313 10.4418 87.9587 10.0272L92.0559 9.21942Z",
    fill: "#313131"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M91.93 11.7563L91.865 12.7633L87.6719 14.0093C87.7266 13.3274 87.7985 12.4169 87.8499 11.7365C89.0753 11.7392 90.7046 11.7258 91.93 11.7563Z",
    fill: "#313131"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1975 3.58959C78.7276 4.54425 80.2611 5.49617 81.7911 6.44844L77.6049 7.68652C76.0714 6.73563 74.5413 5.77959 73.0078 4.82903L74.2333 3.61355L77.1975 3.58959Z",
    fill: "#313131"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5545 4.76709L72.5598 4.54392L73.7852 3.32842L72.9227 2.79239L70.2938 2.89405L69.7941 3.06246L68.6953 4.22968L69.5545 4.76709Z",
    fill: "#313131"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8992 8.49292L86.8019 9.30176C85.8572 9.14396 84.601 8.929 83.6562 8.7777C84.1492 8.33648 84.8029 7.74022 85.3095 7.31235C88.6503 7.98359 88.8523 8.025 90.8992 8.49292Z",
    fill: "#313131"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5618 7.17253C84.062 7.61786 83.3946 8.20319 82.9085 8.66187C81.4366 8.45341 79.4719 8.18197 78 7.99062L82.1965 6.74466L84.5618 7.17253Z",
    fill: "#313131"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5219 14.8573C88.0554 15.8133 89.5888 16.768 91.1189 17.7199L89.8661 19.1093L86.847 19.5022C85.3136 18.5475 83.7835 17.5956 82.25 16.641L86.5219 14.8573Z",
    fill: "#313131"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3305 19.3932L91.1965 19.9306L89.93 21.4161L86.8938 21.907L86.0312 21.3692L87.3114 19.7875L90.3305 19.3932Z",
    fill: "#313131"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3472 10.4523C86.2787 11.3255 86.2103 12.197 86.1418 13.0702C84.8993 13.1663 83.2391 13.279 82 13.4019C82.0411 12.9271 82.0959 12.2935 82.1369 11.8146L86.3472 10.4523Z",
    fill: "#313131"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0899 13.4307L85.9974 14.5979L81.7188 16.3884C81.7872 15.6073 81.8762 14.5698 81.9447 13.7904C83.1872 13.6768 84.8439 13.5121 86.0899 13.4307Z",
    fill: "#313131"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3421 5.41654C72.8756 6.3712 74.4057 7.3231 75.9358 8.27777L71.6639 10.0574C70.1339 9.10682 68.6004 8.15079 67.0703 7.20024L68.3334 5.71467L71.3421 5.41654Z",
    fill: "#313131"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6126 7.40576L66.6487 6.91662L67.9118 5.43107L67.0492 4.89366L64.3828 5.23595L63.8795 5.46562L62.75 6.86836L63.6126 7.40576Z",
    fill: "#313131"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1636 9.72581L80.9534 11.0881C79.9984 10.9961 78.7284 10.865 77.7734 10.7808C78.2869 10.2259 78.9612 9.47969 79.4883 8.93544C82.9455 9.3835 83.0824 9.40062 85.1636 9.72581Z",
    fill: "#313131"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7451 8.84703C78.2282 9.40463 77.5334 10.144 77.0268 10.7163C75.5412 10.6027 73.5593 10.4623 72.0703 10.3703L76.349 8.58381L78.7451 8.84703Z",
    fill: "#313131"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5663 17.4393C81.3673 17.9381 82.4318 18.6025 83.2328 19.0988C83.8113 19.4582 84.5849 19.9412 85.1633 20.3006L83.8832 21.9532L80.847 22.6111C79.3135 21.6564 77.7801 20.7004 76.25 19.7498L80.5663 17.4393Z",
    fill: "#313131"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3379 22.2373L85.2038 22.7751L83.9168 24.5198L80.8704 25.2742L80.0078 24.7327L81.3017 22.8939L84.3379 22.2373Z",
    fill: "#313131"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4742 12.4547C80.3887 13.4549 80.2997 14.4537 80.2141 15.4498C78.9579 15.66 77.2806 15.9194 76.0312 16.1519C76.0792 15.6145 76.1408 14.8963 76.1887 14.3589L80.4742 12.4547Z",
    fill: "#313131"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1583 15.8615L80.0454 17.1852L75.7188 19.5022C75.7941 18.6266 75.8967 17.4594 75.972 16.5862C77.2283 16.364 78.8987 16.0567 80.1583 15.8615Z",
    fill: "#313131"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4101 7.99776C66.2111 8.49785 67.2756 9.15847 68.0766 9.65822C68.6551 10.018 69.4252 10.4968 70.0037 10.859L65.6874 13.1667C64.1539 12.2121 62.6238 11.2602 61.0938 10.3055L62.3739 8.55946L65.4101 7.99776Z",
    fill: "#313131"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5813 10.7703L60.6312 10.0203L61.9114 8.27527L61.0522 7.73786L58.3686 8.30882L57.8586 8.60286L56.7188 10.2356L57.5813 10.7703Z",
    fill: "#313131"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3097 11.7288L75.0242 13.6316C74.0624 13.5967 72.7787 13.5525 71.8203 13.5286C72.344 12.8655 73.0389 11.9708 73.5763 11.317C77.0677 11.5364 77.2046 11.5429 79.3097 11.7288Z",
    fill: "#313131"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8101 11.2773C72.2795 11.9472 71.5675 12.8351 71.0507 13.5115C69.5548 13.4954 67.5627 13.4807 66.0703 13.4848L70.3935 11.1678L72.8101 11.2773Z",
    fill: "#313131"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5835 20.748C75.3844 21.244 76.449 21.9087 77.2465 22.4084C77.8284 22.7682 78.602 23.2508 79.1805 23.6092L77.8935 25.5199L74.847 26.4304C73.317 25.4785 71.7835 24.5238 70.25 23.5692L74.5835 20.748Z",
    fill: "#313131"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3344 25.8035L79.197 26.3412L77.9066 28.344L74.8738 29.3401L74.0078 28.8027L75.2914 26.7144L78.3344 25.8035Z",
    fill: "#313131"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M74.511 15.2028C74.4151 16.3259 74.3158 17.4449 74.22 18.5669C72.9603 18.8784 71.2762 19.2861 70.0234 19.626C70.0714 19.027 70.1364 18.226 70.1878 17.6297L74.511 15.2028Z",
    fill: "#313131"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1686 19.023L74.0522 20.5017L69.7188 23.3257C69.7941 22.3604 69.8933 21.07 69.972 20.1047C71.2283 19.7757 72.9055 19.3239 74.1686 19.023Z",
    fill: "#313131"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M59.396 11.3086C60.926 12.2592 62.4595 13.2152 63.9895 14.1658L59.6561 16.9873C58.1261 16.035 56.596 15.0804 55.0625 14.1285L56.353 12.1229L59.396 11.3086Z",
    fill: "#313131"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5579 14.8406L54.5941 13.8445L55.8845 11.839L55.0219 11.304L52.3315 12.1022L51.8249 12.4538L50.6953 14.3032L51.5579 14.8406Z",
    fill: "#313131"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3308 14.4772L69.0076 16.9013C68.0423 16.9318 66.7587 16.9653 65.7969 17.0002C66.324 16.2301 67.0257 15.1963 67.5666 14.433C71.0751 14.4289 71.212 14.4289 73.3308 14.4772Z",
    fill: "#313131"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8003 14.4402C66.2664 15.2172 65.551 16.2478 65.0273 17.0317C63.5349 17.1063 61.5427 17.2162 60.0469 17.3124L64.3803 14.4843L66.8003 14.4402Z",
    fill: "#313131"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5527 24.7612C70.0827 25.7158 71.6162 26.6705 73.1497 27.6251L71.8729 29.7792L68.847 30.9382C67.3136 29.9836 65.7801 29.0289 64.25 28.0742L68.5527 24.7612Z",
    fill: "#313131"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3446 30.0623L73.2072 30.6038L71.9339 32.8486L68.9251 34.0884L68.0625 33.5506L69.3187 31.2189L72.3446 30.0623Z",
    fill: "#313131"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4806 18.6748C68.3814 19.9143 68.2821 21.1527 68.1897 22.3921C66.93 22.8091 65.2494 23.3533 64 23.7959C64.0479 23.138 64.1095 22.2624 64.1574 21.6045L68.4806 18.6748Z",
    fill: "#313131"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M68.169 22.894L68.0527 24.5199L63.75 27.8374C63.8185 26.7838 63.9109 25.3756 63.9828 24.322C65.2356 23.8904 66.906 23.302 68.169 22.894Z",
    fill: "#313131"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3886 15.319C54.9186 16.2736 56.4487 17.2256 57.9822 18.1802L53.6795 21.4937C52.146 20.539 50.616 19.5867 49.0859 18.632L50.3558 16.3832L53.3886 15.319Z",
    fill: "#313131"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6126 19.5876L48.6248 18.3496L49.8947 16.1007L49.0321 15.5629L46.3588 16.5792L45.8556 16.9896L44.75 19.0516L45.6126 19.5876Z",
    fill: "#313131"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3005 17.9477L62.9773 20.8788C62.0155 20.9644 60.7353 21.0767 59.7734 21.1729C60.3006 20.2959 60.9954 19.1259 61.5363 18.2592C64.9763 18.0439 65.1817 18.0333 67.3005 17.9477Z",
    fill: "#313131"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7896 18.3132C60.259 19.1915 59.547 20.3629 59.0302 21.2494C57.5412 21.4137 55.5559 21.6424 54.0703 21.8245L58.3695 18.5042L60.7896 18.3132Z",
    fill: "#313131"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5936 29.4565C64.1236 30.4112 65.6571 31.3634 67.1906 32.3181L65.9378 34.7179L62.9564 36.1073C61.4229 35.1526 59.8894 34.1966 58.3594 33.246L62.5936 29.4565Z",
    fill: "#313131"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3884 35.0019L67.2544 35.5393L66.0222 38.021L63.0579 39.4932L62.1953 38.9517L63.407 36.3909L66.3884 35.0019Z",
    fill: "#313131"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4893 22.8455C62.3969 24.1986 62.3045 25.5503 62.2189 26.9062C60.973 27.4223 59.306 28.1001 58.0703 28.6416C58.108 27.9289 58.1593 26.9811 58.197 26.2685L62.4893 22.8455Z",
    fill: "#313131"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1694 27.4543L62.0633 29.2271L57.8359 33.0166C57.8873 31.8733 57.9626 30.3505 58.0207 29.2113C59.2633 28.6804 60.9166 27.9609 62.1694 27.4543Z",
    fill: "#313131"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4061 20.0147C48.9361 20.9669 50.4662 21.9216 51.9997 22.8735L47.7655 26.6627C46.232 25.7108 44.7019 24.7562 43.1719 23.8042L44.3973 21.3226L47.4061 20.0147Z",
    fill: "#313131"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7688 24.9905L42.7365 23.522L43.9619 21.0404L43.0994 20.503L40.4671 21.7212L39.9708 22.1864L38.9062 24.4527L39.7688 24.9905Z",
    fill: "#313131"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3092 22.118L57.0168 25.541C56.0653 25.6854 54.7953 25.8699 53.8438 26.0171C54.3572 25.045 55.0384 23.7412 55.5655 22.7759C58.9885 22.3545 59.1938 22.3306 61.3092 22.118Z",
    fill: "#313131"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M54.809 22.8699C54.2887 23.8499 53.5904 25.1496 53.0872 26.1364C51.6119 26.3867 49.6437 26.7313 48.1719 26.999L52.3992 23.2095L54.809 22.8699Z",
    fill: "#313131"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7375 34.8056C57.535 35.3056 58.5996 35.9663 59.4005 36.4664C59.979 36.8261 60.7526 37.3088 61.3345 37.6672L60.1296 40.2997L57.2064 41.915C55.6729 40.9604 54.1394 40.0081 52.6094 39.0535L56.7375 34.8056Z",
    fill: "#313131"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5733 40.5839L61.4359 41.1213L60.2618 43.8292L57.3626 45.5232L56.5 44.9868L57.6467 42.2005L60.5733 40.5839Z",
    fill: "#313131"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5214 27.6913C56.4461 29.1566 56.3708 30.621 56.3057 32.0864C55.0769 32.6987 53.4339 33.5038 52.2188 34.1401C52.2461 33.3741 52.2804 32.3537 52.3078 31.5863L56.5214 27.6913Z",
    fill: "#313131"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2859 32.6744L56.2072 34.5851L52.0859 38.833C52.1202 37.6069 52.1681 35.9742 52.2057 34.7522C53.4277 34.1264 55.0536 33.2799 56.2859 32.6744Z",
    fill: "#313131"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5499 25.3667C43.08 26.3213 44.6101 27.2733 46.1435 28.2241L42.0155 32.472C40.4854 31.5215 38.9519 30.5655 37.4219 29.6146L38.5925 26.907L41.5499 25.3667Z",
    fill: "#313131"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0701 31.0237L36.9762 29.3296L38.1434 26.6221L37.2842 26.0847L34.6999 27.5059L34.2173 28.0221L33.2109 30.4863L34.0701 31.0237Z",
    fill: "#313131"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3603 26.9639L51.1466 30.8589C50.2053 31.054 48.9491 31.3107 48.0078 31.5127C48.5076 30.4458 49.1613 29.015 49.6714 27.9494C53.1251 27.3237 53.262 27.2997 55.3603 26.9639Z",
    fill: "#313131"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9455 28.0902C48.4492 29.1653 47.7749 30.5958 47.2922 31.6778C45.834 32.0105 43.8966 32.4627 42.4453 32.8142L46.5631 28.5663L48.9455 28.0902Z",
    fill: "#313131"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0043 40.794C52.5378 41.7449 54.0679 42.701 55.6014 43.6556L54.4684 46.5063L51.6205 48.3447C50.087 47.3901 48.5535 46.4354 47.0234 45.4835L51.0043 40.794Z",
    fill: "#313131"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9393 46.7918L55.8053 47.3319L54.7065 50.2548L51.8895 52.1682L51.0234 51.6281L52.0914 48.6261L54.9393 46.7918Z",
    fill: "#313131"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7053 33.191C50.6265 35.5939 50.6094 36.1662 50.5649 37.9003C49.3669 38.6065 47.7581 39.5372 46.5703 40.2632C46.5806 39.4489 46.5943 38.3563 46.608 37.5382L50.7053 33.191Z",
    fill: "#313131"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5385 38.5344L50.4975 40.5748L46.5234 45.2639C46.5269 43.9601 46.5371 42.2206 46.5508 40.9171C47.7454 40.2017 49.3337 39.2296 50.5385 38.5344Z",
    fill: "#313131"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8403 31.3499C37.3703 32.3046 38.9038 33.2551 40.4338 34.2112L36.4529 38.9003C34.9195 37.9456 33.3894 36.9937 31.8594 36.039L32.9513 33.1121L35.8403 31.3499Z",
    fill: "#313131"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5935 37.6654L31.414 35.7547L32.5094 32.8277L31.6502 32.2941L29.1309 33.9067L28.6688 34.4749L27.7344 37.1304L28.5935 37.6654Z",
    fill: "#313131"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5285 32.4614L45.4313 36.811C44.5036 37.0581 43.2679 37.3857 42.3438 37.6396C42.8161 36.4752 43.4322 34.9215 43.9149 33.7649C47.2591 32.9601 47.4576 32.9119 49.5285 32.4614Z",
    fill: "#313131"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1781 33.9501C42.7092 35.1174 42.0725 36.671 41.6139 37.8424C40.1865 38.2569 38.2833 38.8145 36.8594 39.2451L40.8334 34.5598L43.1781 33.9501Z",
    fill: "#313131"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M45.527 47.3926C47.0605 48.3486 48.5905 49.2992 50.124 50.2538L49.0834 53.3147L46.3314 55.3616C44.7979 54.4069 43.2644 53.4509 41.7344 52.5003L45.527 47.3926Z",
    fill: "#313131"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5342 53.6007L50.4002 54.1381L49.3973 57.2763L46.6863 59.3889L45.8203 58.8512L46.7821 55.6462L49.5342 53.6007Z",
    fill: "#313131"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M45.037 39.3155C45.013 41.4921 45.0028 42.4844 45.0028 44.3335C43.8355 45.1304 42.2747 46.1775 41.1212 46.9932C41.1143 46.1268 41.1006 44.9702 41.0938 44.1035L45.037 39.3155Z",
    fill: "#313131"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0198 45.007L45.0267 47.1771L41.234 52.2876C41.2066 50.9047 41.169 49.0662 41.1484 47.6865C42.3088 46.879 43.8457 45.7946 45.0198 45.007Z",
    fill: "#313131"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3395 37.9521C31.8695 38.9027 33.3996 39.8587 34.9331 40.8093L31.1371 45.917C29.607 44.9651 28.0769 44.0104 26.5469 43.0585L27.543 39.9203L30.3395 37.9521Z",
    fill: "#313131"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3938 44.8862L26.1083 42.7749L27.1077 39.6358L26.2486 39.098L23.8114 40.8992L23.3733 41.5184L22.5312 44.3488L23.3938 44.8862Z",
    fill: "#313131"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8841 38.5896L39.9409 43.3749C39.0338 43.6734 37.8255 44.0664 36.9219 44.3713C37.3566 43.1182 37.9282 41.4485 38.3766 40.2022C41.5839 39.2369 41.8441 39.1578 43.8841 38.5896Z",
    fill: "#313131"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6485 40.4234C37.2138 41.6803 36.6251 43.3504 36.204 44.6141C34.8075 45.1033 32.9522 45.7639 31.5625 46.2705L35.3517 41.1604L37.6485 40.4234Z",
    fill: "#313131"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3039 54.5714C41.8374 55.5261 43.3674 56.4811 44.9009 57.4358L43.9938 60.6633L41.4095 62.8201C40.6119 62.3241 39.544 61.6593 38.7465 61.1633C38.1646 60.8012 37.391 60.3182 36.8125 59.9588L40.3039 54.5714Z",
    fill: "#313131"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4346 60.9479L45.3006 61.4856L44.4688 64.7333L41.9598 66.9072L41.0938 66.3698L41.8503 63.1047L44.4346 60.9479Z",
    fill: "#313131"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5987 46.0443C39.6364 48.744 39.6466 49.3844 39.6946 51.3567C38.5753 52.2323 37.076 53.393 35.967 54.2837C35.9293 53.3756 35.878 52.1601 35.8438 51.2537L39.5987 46.0443Z",
    fill: "#313131"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7149 52.0689L39.7833 54.3619L36.2953 59.7466C36.2029 58.3264 36.0831 56.4304 36.0078 55.0065C37.1168 54.1227 38.5921 52.938 39.7149 52.0689Z",
    fill: "#313131"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1164 45.1296C26.6465 46.0843 28.1799 47.0365 29.71 47.9912L26.2186 53.3755C25.4211 52.8795 24.3531 52.2151 23.5555 51.7188C22.9771 51.3566 22.2035 50.8764 21.625 50.5184L22.4534 47.2665L25.1164 45.1296Z",
    fill: "#313131"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6438 52.4033L21.1563 50.2335L21.9846 46.9817L21.1221 46.4481L18.8355 48.3482L18.4419 48.9872L17.7812 51.87L18.6438 52.4033Z",
    fill: "#313131"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4516 45.3188L34.6966 50.5254C33.8204 50.8677 32.6497 51.3196 31.7734 51.6619C32.1602 50.3303 32.6668 48.5507 33.0742 47.2254C36.3328 46.041 36.4595 45.9969 38.4516 45.3188Z",
    fill: "#313131"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3526 47.4838C31.9658 48.8198 31.4386 50.5925 31.0724 51.9309C29.7374 52.4687 27.9609 53.1865 26.6328 53.7307L30.1208 48.3437L32.3526 47.4838Z",
    fill: "#313131"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5157 62.0806C37.0492 63.0352 38.5826 63.9871 40.1161 64.9418L39.4144 68.2179L37.0423 70.4158C35.5088 69.4611 33.9754 68.5051 32.4453 67.5545L35.5157 62.0806Z",
    fill: "#313131"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8685 68.5026L40.7311 69.04L40.1081 72.3253L37.8113 74.5342L36.9453 73.9964L37.493 70.6994L39.8685 68.5026Z",
    fill: "#313131"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4337 53.3345C34.6083 56.6585 34.6151 56.7882 34.7588 58.8218C33.7251 59.7189 32.3388 60.9132 31.3153 61.8237C31.2298 60.9036 31.11 59.6751 31.0312 58.7537L34.4337 53.3345Z",
    fill: "#313131"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8248 59.5442L35.013 61.8694L31.9427 67.342C31.7715 65.9112 31.5525 63.9978 31.3984 62.5605C32.4253 61.6569 33.7877 60.4373 34.8248 59.5442Z",
    fill: "#313131"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3316 52.641C21.1292 53.1369 22.1937 53.8013 22.9947 54.2976C23.5732 54.6598 24.3433 55.14 24.9218 55.4981L21.8514 60.9724C20.3179 60.0177 18.7879 59.0655 17.2578 58.1136L17.8774 54.8244L20.3316 52.641Z",
    fill: "#313131"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5188 60.0315L16.8225 57.8305L17.4386 54.5414L16.5794 54.0037L14.4777 55.9411L14.132 56.5842L13.6562 59.4965L14.5188 60.0315Z",
    fill: "#313131"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2741 52.6086L29.8717 58.0265C29.0433 58.3756 27.9377 58.8449 27.1094 59.2006C27.414 57.8461 27.8008 56.0343 28.126 54.6864C30.8712 53.5633 31.3675 53.3613 33.2741 52.6086Z",
    fill: "#313131"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4636 54.9603C27.1624 56.3202 26.7448 58.1265 26.4607 59.4892C25.2079 60.0372 23.534 60.77 22.2812 61.3276L25.3516 55.8547L27.4636 54.9603Z",
    fill: "#313131"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3369 69.7004C32.8703 70.6551 34.4038 71.6097 35.9339 72.5616L35.4478 75.8617L33.2845 78.0757C31.751 77.121 30.221 76.1691 28.6875 75.2144L31.3369 69.7004Z",
    fill: "#313131"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8782 76.1454L36.7442 76.6869L36.3334 79.9894L34.2454 82.2009L33.3828 81.6635L33.7149 78.3607L35.8782 76.1454Z",
    fill: "#313131"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8173 60.8754C30.1699 64.2371 30.1836 64.3706 30.4369 66.4179C29.4887 67.3311 28.2154 68.5439 27.2809 69.4705C27.144 68.5398 26.9626 67.3003 26.8359 66.3696L29.8173 60.8754Z",
    fill: "#313131"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5182 67.1467L30.8297 69.4917L28.1838 75.0061C27.9373 73.5647 27.6156 71.6444 27.3828 70.203C28.3207 69.286 29.5666 68.0531 30.5182 67.1467Z",
    fill: "#313131"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1494 60.2594C17.6828 61.2114 19.2129 62.166 20.743 63.1179L18.0936 68.6323C16.5636 67.6801 15.0301 66.7254 13.5 65.7735L13.9074 62.4683L16.1494 60.2594Z",
    fill: "#313131"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9529 67.7014L13.0443 65.4898L13.4516 62.1833L12.5891 61.6455L10.6756 63.5966L10.3813 64.2476L10.0938 67.1637L10.9529 67.7014Z",
    fill: "#313131"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6453 60.1484L25.6639 65.6398C24.8835 66.0023 23.8395 66.4809 23.0625 66.8447C23.2781 65.4755 23.552 63.6477 23.7916 62.2812C26.5573 61.0524 26.8448 60.9227 28.6453 60.1484Z",
    fill: "#313131"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1659 62.5665C22.9503 63.9316 22.649 65.7567 22.4539 67.1286C21.2764 67.6835 19.7053 68.4256 18.5312 68.9873L21.1772 63.4729L23.1659 62.5665Z",
    fill: "#313131"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7215 77.3664C29.255 78.321 30.785 79.2771 32.3185 80.2317L32.0447 83.5318L30.097 85.7393C28.5635 84.7873 27.0335 83.8327 25.5 82.878L27.7215 77.3664Z",
    fill: "#313131"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4893 83.8165L33.3553 84.3539L33.1568 87.654L31.2878 89.8522L30.4219 89.3144L30.5417 86.0239L32.4893 83.8165Z",
    fill: "#313131"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7488 68.5199C26.2828 71.8977 26.3068 72.0312 26.6696 74.0785C25.8105 74.9955 24.6569 76.211 23.808 77.1389C23.6232 76.2068 23.3733 74.9688 23.1953 74.0371L25.7488 68.5199Z",
    fill: "#313131"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8063 74.8219L27.2479 77.1591L25.0264 82.6772C24.7012 81.2358 24.2768 79.3156 23.9688 77.8745C24.8176 76.9571 25.9438 75.7283 26.8063 74.8219Z",
    fill: "#313131"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5418 67.9276C14.0719 68.8823 15.6054 69.8342 17.1354 70.7889L14.9139 76.2964C13.3804 75.3445 11.8504 74.3898 10.3203 73.4379L10.512 70.1378L12.5418 67.9276Z",
    fill: "#313131"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99198 75.3499L9.86775 73.153L10.0594 69.8533L9.20029 69.3159L7.47168 71.2639L7.22867 71.9111L7.13281 74.8124L7.99198 75.3499Z",
    fill: "#313131"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5732 67.7941L22.0196 73.3084C21.2906 73.6706 20.315 74.1532 19.5859 74.5171C19.7126 73.1438 19.87 71.3159 20.0207 69.9444C22.8891 68.5776 22.8891 68.5776 24.5732 67.7941Z",
    fill: "#313131"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4273 70.2377C19.3007 71.6069 19.1193 73.4279 19.0131 74.7998C17.911 75.3546 16.4425 76.0967 15.3438 76.6584L17.5652 71.1417L19.4273 70.2377Z",
    fill: "#313131"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7121 85.0254C26.2456 85.9774 27.7756 86.932 29.3091 87.8871L29.2509 91.1669L27.5189 93.3463C25.9854 92.3917 24.4554 91.4394 22.9219 90.4847L24.7121 85.0254Z",
    fill: "#313131"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7164 91.4499L30.5824 91.9914L30.6029 95.2565L28.9462 97.4291L28.0802 96.8889L27.9844 93.6306L29.7164 91.4499Z",
    fill: "#313131"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2819 76.1909C22.9665 79.4427 23.0247 79.706 23.4971 81.7491C22.7269 82.6596 21.6931 83.8645 20.9367 84.7815C20.7005 83.8535 20.3856 82.6223 20.1562 81.6943L22.2819 76.1909Z",
    fill: "#313131"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6727 82.4816L24.2408 84.8123L22.4541 90.2798C22.0502 88.8517 21.5196 86.9451 21.1328 85.5102C21.8927 84.5997 22.9025 83.3815 23.6727 82.4816Z",
    fill: "#313131"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56418 75.581C11.0942 76.5356 12.6277 77.4879 14.1578 78.4426L12.3676 83.9019C10.8375 82.9472 9.304 81.9953 7.77394 81.0444L7.75 77.7713L9.56418 75.581Z",
    fill: "#313131"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6469 82.9268L7.30702 80.7593L7.28308 77.4877L6.42049 76.9527L4.88702 78.874L4.69531 79.5134L4.78774 82.3921L5.6469 82.9268Z",
    fill: "#313131"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1226 75.4646L19.0004 80.9656C18.3192 81.3254 17.4121 81.7971 16.7344 82.1595C16.772 80.7945 16.8063 78.9759 16.8679 77.6176C19.1373 76.4569 19.548 76.2484 21.1226 75.4646Z",
    fill: "#313131"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2957 77.8984C16.258 79.2607 16.1964 81.0752 16.1827 82.4379C15.1592 82.9845 13.7969 83.7133 12.7734 84.2654L14.5636 78.7955L16.2957 77.8984Z",
    fill: "#313131"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22.313 92.5994C23.843 93.5541 25.3765 94.506 26.91 95.4607L27.0709 98.6991L25.5579 100.828C24.0245 99.8732 22.491 98.9227 20.9609 97.9666L22.313 92.5994Z",
    fill: "#313131"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5364 98.9834L28.3989 99.5239L28.6386 102.741L27.2043 104.849L26.3417 104.313L26.0234 101.112L27.5364 98.9834Z",
    fill: "#313131"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 83.8327C20.2879 87.0603 20.3564 87.3238 20.9417 89.3536C20.2639 90.244 19.35 91.4286 18.6825 92.3326C18.3984 91.4139 18.0116 90.1933 17.7344 89.2746L19.4219 83.8327Z",
    fill: "#313131"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1371 90.08L21.8353 92.3864L20.4867 97.7615C20.0006 96.3509 19.364 94.4683 18.8984 93.0508C19.5693 92.1578 20.4559 90.9638 21.1371 90.08Z",
    fill: "#313131"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15761 83.1602C8.68766 84.1107 10.2177 85.0668 11.7512 86.0177L10.3991 91.3845C8.86565 90.4299 7.33557 89.4779 5.80552 88.5274L5.5625 85.306L7.15761 83.1602Z",
    fill: "#313131"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90453 90.3499L5.34558 88.2413L5.10257 85.02L4.23998 84.4826L2.89817 86.3625L2.75781 86.9882L3.04537 89.8121L3.90453 90.3499Z",
    fill: "#313131"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2504 83.1042L16.5594 88.546C15.933 88.8952 15.091 89.3576 14.4646 89.7068C14.4133 88.3616 14.3277 86.5672 14.2969 85.2193C16.159 84.2167 16.7853 83.8772 18.2504 83.1042Z",
    fill: "#313131"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7743 85.497C13.8291 86.8422 13.8873 88.6365 13.9626 89.9818C13.0178 90.5085 11.7616 91.213 10.8203 91.7439L12.1689 86.3743L13.7743 85.497Z",
    fill: "#313131"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5233 100.038C22.0533 100.99 23.5868 101.944 25.1203 102.899L25.5003 106.072L24.2098 108.125C22.6763 107.171 21.1429 106.216 19.6094 105.264L20.5233 100.038Z",
    fill: "#313131"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9623 106.356L26.8283 106.894L27.287 110.036L26.0753 112.066L25.2093 111.528L24.6719 108.41L25.9623 106.356Z",
    fill: "#313131"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1591 91.3812C18.1996 94.5745 18.2852 94.835 18.9835 96.834C18.3947 97.7004 17.604 98.8532 17.029 99.7261C16.6901 98.8262 16.2349 97.6244 15.9062 96.7204L17.1591 91.3812Z",
    fill: "#313131"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2186 97.5494L20.0436 99.825L19.1365 105.056C18.5717 103.673 17.8289 101.828 17.2812 100.435C17.8632 99.5682 18.6264 98.4092 19.2186 97.5494Z",
    fill: "#313131"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33697 90.5978C6.86703 91.5487 8.39706 92.5006 9.92711 93.4553L9.02007 98.6821C7.48658 97.7275 5.95651 96.7752 4.42645 95.8246L3.96094 92.6759L5.33697 90.5978Z",
    fill: "#313131"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7827 97.5662L3.99786 95.5391L3.53573 92.3903L2.67318 91.8567L1.52646 93.6671L1.4375 94.2767L1.92353 97.0284L2.7827 97.5662Z",
    fill: "#313131"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9813 90.6552L14.732 95.9957C14.1535 96.3273 13.3834 96.7686 12.8083 97.104C12.6611 95.7831 12.4557 94.0234 12.3359 92.6983C13.9139 91.809 14.6327 91.4055 15.9813 90.6552Z",
    fill: "#313131"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8668 92.9659C12.0105 94.2871 12.1885 96.0465 12.3562 97.3651C11.4937 97.8638 10.3435 98.535 9.48438 99.0416L10.3915 93.8083L11.8668 92.9659Z",
    fill: "#313131"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3483 107.269C20.8818 108.225 22.4118 109.176 23.9453 110.13L24.5478 113.215L23.4798 115.181C21.9498 114.228 20.4163 113.274 18.8828 112.318L19.3483 107.269Z",
    fill: "#313131"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9898 113.5L25.8524 114.04L26.537 117.094L25.5512 119.01L24.6852 118.473L23.9219 115.464L24.9898 113.5Z",
    fill: "#313131"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4953 98.7784C16.7686 102.044 16.82 102.171 17.6312 104.128C17.1349 104.96 16.4674 106.066 15.9813 106.908C15.5945 106.026 15.0709 104.85 14.6875 103.968L15.4953 98.7784Z",
    fill: "#313131"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9106 104.831L18.8656 107.056L18.4069 112.104C17.7634 110.755 16.9111 108.955 16.2812 107.6C16.7707 106.768 17.4108 105.656 17.9106 104.831Z",
    fill: "#313131"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17354 97.8297C5.7036 98.782 7.2371 99.7367 8.76716 100.687L8.30164 105.736C6.77158 104.786 5.24151 103.833 3.70803 102.879L3.02344 99.8222L4.17354 97.8297Z",
    fill: "#313131"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2625 104.511L3.25174 102.594L2.56372 99.5376L1.70456 98.9998L0.752971 100.736L0.71875 101.321L1.40334 103.974L2.2625 104.511Z",
    fill: "#313131"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3218 98.0528L13.5139 103.242C12.9868 103.553 12.2885 103.972 11.7614 104.282C11.5252 102.999 11.1966 101.284 10.9844 99.9967C12.0968 99.347 13.2059 98.6973 14.3218 98.0528Z",
    fill: "#313131"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5539 100.247C10.7901 101.53 11.0913 103.246 11.3514 104.525C10.571 104.995 9.53043 105.618 8.75 106.087L9.20866 101.041L10.5539 100.247Z",
    fill: "#313131"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7837 114.24C20.3172 115.194 21.8507 116.145 23.3807 117.101L24.2091 120.075L23.3705 121.92C22.5695 121.424 21.505 120.759 20.7074 120.261C20.1255 119.901 19.3519 119.418 18.7734 119.058L18.7837 114.24Z",
    fill: "#313131"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M24.678 120.361L25.5406 120.898L26.4511 123.831L25.6912 125.625L24.8286 125.084L23.8359 122.206L24.678 120.361Z",
    fill: "#313131"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4488 105.96C15.8556 109.017 15.9686 109.27 16.8996 111.177C16.4957 111.964 15.948 113.011 15.5578 113.805C15.1163 112.954 14.5241 111.817 14.0859 110.957L14.4488 105.96Z",
    fill: "#313131"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2241 111.858L18.3126 114.028L18.3057 118.84C17.5801 117.537 16.6182 115.79 15.9062 114.476C16.2999 113.693 16.8202 112.638 17.2241 111.858Z",
    fill: "#313131"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61168 104.799C5.14516 105.751 6.67523 106.706 8.20529 107.657L8.19501 112.476C6.66153 111.524 5.1315 110.57 3.60144 109.619L2.6875 106.682L3.61168 104.799Z",
    fill: "#313131"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3722 111.12L3.13551 109.334L2.21819 106.394L1.35902 105.86L0.609375 107.489L0.626506 108.044L1.50961 110.583L2.3722 111.12Z",
    fill: "#313131"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2803 105.23L12.9175 110.231C12.4451 110.519 11.8153 110.898 11.3429 111.182C11.0143 109.94 10.5625 108.29 10.2578 107.041C11.2642 106.435 12.2705 105.832 13.2803 105.23Z",
    fill: "#313131"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85479 107.274C10.1868 108.513 10.6113 110.17 10.9638 111.405C10.2655 111.829 9.33452 112.395 8.63281 112.823L8.64305 108.013L9.85479 107.274Z",
    fill: "#313131"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8594 120.881C20.3929 121.836 21.9229 122.788 23.4564 123.743L24.5141 126.591L23.9014 128.285C22.3679 127.334 20.8379 126.378 19.3044 125.424L18.8594 120.881Z",
    fill: "#313131"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9721 126.874L25.8381 127.41L26.9779 130.197L26.4474 131.836L25.5813 131.3L24.3594 128.568L24.9721 126.874Z",
    fill: "#313131"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 112.856C15.6694 115.886 15.7686 116.068 16.8126 117.909C16.5045 118.645 16.0801 119.621 15.7857 120.363C15.2894 119.538 14.6253 118.443 14.1393 117.618L14.0469 112.856Z",
    fill: "#313131"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1904 118.565L18.4124 120.664L18.8608 125.2C18.0496 123.947 16.9782 122.273 16.1875 121.009C16.4853 120.274 16.8755 119.295 17.1904 118.565Z",
    fill: "#313131"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68267 111.44C4.48364 111.937 5.54815 112.601 6.34569 113.097C6.92759 113.456 7.69776 113.939 8.27624 114.299L8.72124 118.845C7.19118 117.89 5.65769 116.938 4.12763 115.983L2.98438 113.193L3.68267 111.44Z",
    fill: "#313131"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12888 117.338L3.66288 115.698L2.51963 112.909L1.66046 112.374L1.10938 113.871L1.18124 114.395L2.26972 116.8L3.12888 117.338Z",
    fill: "#313131"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8794 112.132L12.9719 116.894C12.5508 117.146 11.9929 117.484 11.5718 117.741C11.1508 116.554 10.5689 114.972 10.1719 113.778C11.0755 113.227 11.9758 112.679 12.8794 112.132Z",
    fill: "#313131"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82824 113.987C10.2527 115.171 10.8004 116.76 11.2488 117.937C10.6361 118.309 9.81456 118.81 9.19843 119.183L8.75 114.651L9.82824 113.987Z",
    fill: "#313131"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5625 127.129C21.0926 128.081 22.626 129.035 24.1595 129.991L25.4465 132.682L25.0632 134.215C23.5331 133.259 21.9996 132.305 20.4661 131.35L19.5625 127.129Z",
    fill: "#313131"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9112 132.967L26.7772 133.504L28.1464 136.126L27.8486 137.594L26.9826 137.057L25.5312 134.497L25.9112 132.967Z",
    fill: "#313131"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 119.414C16.1018 122.385 16.1737 122.501 17.3341 124.268C17.1219 124.943 16.824 125.836 16.6255 126.514C16.0778 125.727 15.3419 124.678 14.7977 123.888L14.25 119.414Z",
    fill: "#313131"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7583 124.902L19.1172 126.911L20.0243 131.125C19.1309 129.933 17.9466 128.335 17.0703 127.129C17.2757 126.462 17.5358 125.567 17.7583 124.902Z",
    fill: "#313131"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40644 117.691C5.9365 118.643 7.46657 119.594 9.00005 120.55L9.90372 124.774C8.37366 123.818 6.84359 122.867 5.31011 121.911L3.9375 119.286L4.40644 117.691Z",
    fill: "#313131"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54971 123.094L4.85093 121.626L3.47832 119L2.61573 118.466L2.27344 119.818L2.40008 120.301L3.68712 122.557L4.54971 123.094Z",
    fill: "#313131"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1001 118.686L13.6478 123.163C13.2816 123.382 12.7955 123.673 12.4293 123.893C11.9124 122.766 11.2038 121.274 10.7109 120.137C11.5085 119.654 12.306 119.173 13.1001 118.686Z",
    fill: "#313131"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3822 120.318C10.8991 121.441 11.5768 122.946 12.1211 124.059C11.5905 124.374 10.8786 124.791 10.348 125.106L9.4375 120.892L10.3822 120.318Z",
    fill: "#313131"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9062 132.927C21.7038 133.423 22.7683 134.086 23.5693 134.583C24.1478 134.946 24.9214 135.424 25.5033 135.788L27.0231 138.301L26.8759 139.646C25.3424 138.691 23.8089 137.735 22.2754 136.784L20.9062 132.927Z",
    fill: "#313131"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4909 138.581L28.3569 139.121L29.9589 141.555L29.8938 142.829L29.0312 142.291L27.3438 139.929L27.4909 138.581Z",
    fill: "#313131"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 125.567C17.1407 128.4 17.2194 128.514 18.503 130.195C18.3832 130.794 18.212 131.595 18.1128 132.197C17.5103 131.454 16.7025 130.461 16.1035 129.708L15.0938 125.567Z",
    fill: "#313131"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M18.979 130.794L20.4714 132.7L21.8475 136.547C20.8685 135.428 19.5712 133.923 18.6094 132.782C18.7189 132.183 18.8524 131.386 18.979 130.794Z",
    fill: "#313131"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74402 123.485C7.27408 124.437 8.8041 125.387 10.3342 126.343L11.7068 130.201C10.1767 129.246 8.64664 128.294 7.11658 127.342L5.50781 124.902L5.74402 123.485Z",
    fill: "#313131"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59892 128.327L6.66736 127.058L5.06202 124.617L4.19943 124.084L4.0625 125.271L4.24393 125.71L5.73975 127.791L6.59892 128.327Z",
    fill: "#313131"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M13.939 124.836L14.9488 128.981C14.6373 129.16 14.2232 129.395 13.9117 129.573C13.299 128.52 12.4637 127.126 11.875 126.058C12.563 125.654 13.251 125.247 13.939 124.836Z",
    fill: "#313131"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6203 126.21C12.233 127.261 13.0374 128.675 13.6775 129.708C13.2325 129.958 12.6369 130.287 12.1885 130.533L10.8125 126.686L11.6203 126.21Z",
    fill: "#313131"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8984 138.211C23.696 138.707 24.7605 139.371 25.5615 139.867C26.14 140.227 26.9136 140.71 27.4955 141.072L29.248 143.376L29.3336 144.512C27.8035 143.558 26.27 142.606 24.7366 141.651L22.8984 138.211Z",
    fill: "#313131"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7109 143.661L30.577 144.198L32.4151 146.423L32.5862 147.481L31.7236 146.943L29.7999 144.797L29.7109 143.661Z",
    fill: "#313131"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5938 131.249C18.7502 133.823 18.9247 134.035 20.3282 135.617C20.3042 136.137 20.2597 136.828 20.2631 137.349C19.6059 136.65 18.7228 135.723 18.0724 135.018L16.5938 131.249Z",
    fill: "#313131"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8414 136.181L22.4741 137.976L24.3191 141.412C23.2545 140.363 21.8443 138.961 20.7969 137.896C20.8071 137.383 20.8071 136.694 20.8414 136.181Z",
    fill: "#313131"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75343 128.766C9.28348 129.721 10.8136 130.673 12.3436 131.628L14.1852 135.068C12.6551 134.116 11.125 133.161 9.59155 132.21L7.75 129.977L7.75343 128.766Z",
    fill: "#313131"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29373 132.978L9.12601 131.927L7.28446 129.698L6.42188 129.162L6.49032 130.167L6.72995 130.551L8.43457 132.444L9.29373 132.978Z",
    fill: "#313131"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4342 130.522L16.9129 134.291L16.0571 134.726C15.3451 133.758 14.3799 132.474 13.6953 131.485C14.753 130.906 14.753 130.906 15.4342 130.522Z",
    fill: "#313131"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4834 131.601C14.192 132.569 15.1264 133.874 15.8658 134.822C15.503 134.995 15.0203 135.225 14.6575 135.393L12.8125 131.957L13.4834 131.601Z",
    fill: "#313131"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5312 142.908C27.0647 143.863 28.5982 144.817 30.1283 145.769L32.1204 147.85L32.4456 148.754C30.9122 147.802 29.3787 146.847 27.8486 145.892L25.5312 142.908Z",
    fill: "#313131"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6094 148.134L33.4754 148.672L35.5497 150.667L35.9604 151.485L35.0979 150.943L32.9345 149.041L32.6094 148.134Z",
    fill: "#313131"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 136.4C21.194 138.909 21.2898 139.005 22.813 140.477C22.8883 140.908 22.9705 141.487 23.0732 141.908C22.3612 141.261 21.4062 140.402 20.7011 139.748L18.75 136.4Z",
    fill: "#313131"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 141.003L25.1481 142.667L27.4688 145.649C26.3187 144.69 24.7955 143.397 23.6625 142.417C23.5735 141.993 23.4366 141.431 23.375 141.003Z",
    fill: "#313131"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3984 133.466C11.9319 134.421 13.462 135.372 14.992 136.324L17.3094 139.313C16.5084 138.813 15.4439 138.152 14.6429 137.652C14.0644 137.292 13.2943 136.814 12.7158 136.45L10.6346 134.455L10.3984 133.466Z",
    fill: "#313131"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M12.648 136.981L12.2372 136.167L10.1595 134.17L9.29688 133.633L9.57758 134.435L9.86852 134.767L11.7854 136.448L12.648 136.981Z",
    fill: "#313131"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5631 135.673L19.5141 139.021L18.8433 139.284C18.0354 138.404 16.9401 137.244 16.1562 136.344C16.9812 135.964 17.012 135.947 17.5631 135.673Z",
    fill: "#313131"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9881 136.42C16.7993 137.299 17.8673 138.488 18.7025 139.344L17.7783 139.631L15.4609 136.649L15.9881 136.42Z",
    fill: "#313131"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9297 151.945L35.7038 151.658L33.472 149.823C31.942 148.873 30.4085 147.916 28.875 146.962L30.8261 148.766L35.9297 151.945Z",
    fill: "#313131"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9997 153.223L37.0379 152.483L36.1719 151.943L36.3978 152.231L37.9997 153.223Z",
    fill: "#313131"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5469 140.96C24.1962 143.273 24.2989 143.363 25.9454 144.715C26.1199 145.048 26.3356 145.502 26.5409 145.814C25.7708 145.225 24.7371 144.441 23.9737 143.839L21.5469 140.96Z",
    fill: "#313131"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3737 148.486L28.4603 146.717L26.5469 145.196C26.7283 145.521 26.9508 145.966 27.163 146.271L29.1894 147.746L30.3737 148.486Z",
    fill: "#313131"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2366 142.185L18.2889 140.385C16.7589 139.43 15.2288 138.478 13.6953 137.524L14.1711 138.266L15.1364 139.009L20.2366 142.185Z",
    fill: "#313131"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6838 138.723L13.722 137.981L12.8594 137.446L13.0853 137.727L14.6838 138.723Z",
    fill: "#313131"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3873 140.233L22.8142 143.112L22.3349 143.191C21.4244 142.41 20.199 141.387 19.3125 140.579C19.9355 140.398 19.9594 140.391 20.3873 140.233Z",
    fill: "#313131"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8824 143.208L22.2144 143.201C21.2971 142.427 20.0649 141.413 19.1715 140.613L18.7812 140.702L20.6981 142.468L21.8824 143.208Z",
    fill: "#313131"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6469 146.799C26.8562 146.221 25.7951 145.454 25.0078 144.865L26.11 145.84L27.6469 146.799Z",
    fill: "#313131"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9388 145.115L23.8365 144.139L23.3984 144.157L24.9388 145.115Z",
    fill: "#313131"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3035_51698",
    x1: 60.489,
    y1: 127.09,
    x2: 106.121,
    y2: 48.0532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A7B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3035_51698",
    x1: 55.8441,
    y1: 124.376,
    x2: 101.446,
    y2: 45.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3035_51698",
    x1: 97.2621,
    y1: 79.0851,
    x2: 104.726,
    y2: 66.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117877,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12701,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127027,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472124,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472973,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567476,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569503,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617699,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672601,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766853,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.810642,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846108,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3035_51698",
    x1: 77.2442,
    y1: 72.9831,
    x2: 95.0522,
    y2: 42.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3035_51698",
    x1: 65.1956,
    y1: 122.358,
    x2: 76.2189,
    y2: 103.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3035_51698",
    x1: 104.123,
    y1: 88.7504,
    x2: 104.283,
    y2: 88.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3035_51698",
    x1: 44.2745,
    y1: 115.817,
    x2: 65.89,
    y2: 78.3785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3035_51698",
    x1: 98.4208,
    y1: 104.528,
    x2: 59.1715,
    y2: 65.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367955,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121058,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121219,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309205,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309667,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824661,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835708,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90218,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933063,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3035_51698",
    x1: 81.9214,
    y1: 90.345,
    x2: 75.7643,
    y2: 79.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153892,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189358,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296473,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527027,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527876,
    stopColor: "#A0A0A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872973,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87299,
    stopColor: "#91929A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882123,
    stopColor: "#84858F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84858F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3035_51698",
    x1: 80.0881,
    y1: 88.2425,
    x2: 75.7185,
    y2: 80.6741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0367955,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121058,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121219,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309205,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309667,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824661,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835708,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90218,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933063,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF2F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3035_51698",
    x1: 47.3934,
    y1: 124.193,
    x2: 97.0147,
    y2: 38.2464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117877,
    stopColor: "#A5A7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12701,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127027,
    stopColor: "#B3B4BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472124,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472973,
    stopColor: "#C3C3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567476,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569503,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617699,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672601,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766853,
    stopColor: "#EEF2F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.810642,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846108,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyperMaping);
export default __webpack_public_path__ + "static/media/Typer_maping.a7b868054c88477d7fecad60ee62af22.svg";
export { ForwardRef as ReactComponent };